import type { IconButtonProps } from '@mui/material';
import { IconButton, useTheme } from '@mui/material';
import { IconSend } from '@tabler/icons-react';
import { useAppSelector } from 'hooks';
import { selectLegibleElementColor } from 'reducers/config';

export const SendMessageButton = (props: IconButtonProps) => {
  const theme = useTheme();
  const legibleElementColor = useAppSelector(selectLegibleElementColor);

  return (
    <IconButton
      {...props}
      disabled={!!props['aria-disabled']}
      sx={{
        ...props.sx,
        '&:focus': { outline: 'none' },
        '&:focus-visible': {
          outline: '2px solid var(--legible-text-color)',
        },
        padding: 0,
      }}
    >
      <IconSend
        color={
          props['aria-disabled']
            ? theme.palette.colors.slate[200]
            : legibleElementColor
        }
        size={24}
      />
    </IconButton>
  );
};
